import type { FecImportWizardStep } from '../hooks/useFecImportSession'

interface GetFecImportModalChromeParams {
  defaultTitle: string
  finaliseTitle: string
  /** Resolve items is its own step in the stepper only when there is something to resolve (ADVP-600). */
  hasResolveItemsStep?: boolean
  isFinalisingMappings: boolean
  isMappingsConfirmed: boolean
  isOrganizationFeatureLoading: boolean
  mappingTitle: string
  step: FecImportWizardStep
}

export interface FecImportModalChrome {
  currentStep: number
  isContentCentered: boolean
  showStepper: boolean
  title: string
}

export const getFecImportModalChrome = ({
  defaultTitle,
  finaliseTitle,
  hasResolveItemsStep = false,
  isFinalisingMappings,
  isMappingsConfirmed,
  isOrganizationFeatureLoading,
  mappingTitle,
  step,
}: GetFecImportModalChromeParams): FecImportModalChrome => {
  // Review mappings and Finalise setup move one step on when Resolve items takes the second place.
  const stepOffset = hasResolveItemsStep ? 1 : 0

  if (isOrganizationFeatureLoading) {
    return {
      currentStep: 1,
      isContentCentered: true,
      showStepper: false,
      title: defaultTitle,
    }
  }

  if (isMappingsConfirmed) {
    return {
      currentStep: 3 + stepOffset,
      isContentCentered: true,
      showStepper: false,
      title: defaultTitle,
    }
  }

  // The content shows the restoring and load-error screens before Finalise, so the chrome does too.
  if (isFinalisingMappings && step !== 'restoring' && step !== 'load-error') {
    return {
      currentStep: 3 + stepOffset,
      isContentCentered: false,
      showStepper: true,
      title: finaliseTitle,
    }
  }

  if (step === 'mapping') {
    return {
      currentStep: 2 + stepOffset,
      isContentCentered: false,
      showStepper: true,
      title: mappingTitle,
    }
  }

  return {
    currentStep: 1,
    isContentCentered: true,
    showStepper: true,
    title: defaultTitle,
  }
}
